import React from 'react'
import { useState } from 'react'
import MyButton from '../../UI/form/MyButton'
import MyModal from '../../UI/modal/MyModal'
import AddIcon from '@mui/icons-material/Add';
import FileUploadForm from './FileUploadForm';

const FileUploadButton = ({ tableOwnerId, tableOwnerType, type }) => {

    const [open, setOpen] = useState(false)

  return (
    <>
        <MyButton
            onClick={e => setOpen(true)}
            size='smExtra'
        >
            <AddIcon />
        </MyButton>        

        <MyModal
            open={open}
            setOpen={setOpen}
            header={'Додавання файлів'}
            disableClickOutside={true}
            content={
                <FileUploadForm
                    tableOwnerId={tableOwnerId}
                    tableOwnerType={tableOwnerType}
                    type={type}
                    setOpen={setOpen}
                />
            }
        />
    </>
  )
}

export default FileUploadButton